import { memo, FC } from 'react';

import PriceCartItemHH from 'src/components/Price/PriceCart/PriceCartItemHH';
import { PriceCartProductType } from 'src/models/price/priceCart';

import Title from 'src/components/Price/PriceCart/PriceCartProduct/PayForPerformance/Title';

export interface PayForPerformanceProps {
    product: PriceCartProductType;
}

const PayForPerformance: FC<PayForPerformanceProps> = ({ product }) => (
    <PriceCartItemHH product={product} title={<Title />} />
);

export default memo(PayForPerformance);
